import { create } from 'zustand';
import { SearchOption } from '../components/SearchSelector';

interface SearchSelectorState {
  searchValue: string;
  selectedOption: SearchOption | null;
  setSearchValue: (value: string) => void;
  setSelectedOption: (option: SearchOption | null) => void;
  resetSearch: () => void;
}

export const useSearchSelectorStore = create<SearchSelectorState>((set) => ({
  searchValue: '',
  selectedOption: null,
  setSearchValue: (value: string) => set({ searchValue: value }),
  setSelectedOption: (option: SearchOption | null) => set({ selectedOption: option }),
  resetSearch: () => set({ searchValue: '' })
})); 